import { Subscription } from "../classes/Subscription";

const subscription = new Subscription();
subscription.init();
